import {
  GET_SYSTEM_WALLET_LIST,
  GET_SYSTEM_WALLET_LIST_SUCCESS,
  GET_SYSTEM_WALLET_LIST_FAILURE,
  GET_SYSTEM_WALLET_DATA,
  GET_SYSTEM_WALLET_DATA_SUCCESS,
  GET_SYSTEM_WALLET_DATA_FAILURE,
  UPDATE_SYSTEM_WALLET,
  UPDATE_SYSTEM_WALLET_SUCCESS,
  UPDATE_SYSTEM_WALLET_FAILURE,
  TOPUP_SYSTEM_WALLET,
  TOPUP_SYSTEM_WALLET_SUCCESS,
  TOPUP_SYSTEM_WALLET_FAILURE,
  GET_SYSTEM_WALLET_TRANSACTIONS,
  GET_SYSTEM_WALLET_TRANSACTIONS_SUCCESS,
  GET_SYSTEM_WALLET_TRANSACTIONS_FAILURE,
  ADJUST_SYSTEM_WALLET,
  ADJUST_SYSTEM_WALLET_SUCCESS,
  ADJUST_SYSTEM_WALLET_FAILURE,
  GET_MY_WALLET,
  GET_MY_WALLET_SUCCESS,
  GET_MY_WALLET_FAILURE,
  GET_MY_WALLET_TRANSACTIONS,
  GET_MY_WALLET_TRANSACTIONS_SUCCESS,
  GET_MY_WALLET_TRANSACTIONS_FAILURE,
  TOPUP_MY_WALLET,
  TOPUP_MY_WALLET_SUCCESS,
  TOPUP_MY_WALLET_FAILURE,
  UPDATE_MY_WALLET,
  UPDATE_MY_WALLET_SUCCESS,
  UPDATE_MY_WALLET_FAILURE,
  GET_SYSTEM_WALLET_SERVICE_TYPE_LIST,
  GET_SYSTEM_WALLET_SERVICE_TYPE_LIST_SUCCESS,
  GET_SYSTEM_WALLET_SERVICE_TYPE_LIST_FAILURE,
  CREATE_SYSTEM_WALLET_SERVICE_TYPE,
  CREATE_SYSTEM_WALLET_SERVICE_TYPE_SUCCESS,
  CREATE_SYSTEM_WALLET_SERVICE_TYPE_FAILURE,
  UPDATE_SYSTEM_WALLET_SERVICE_TYPE,
  UPDATE_SYSTEM_WALLET_SERVICE_TYPE_SUCCESS,
  UPDATE_SYSTEM_WALLET_SERVICE_TYPE_FAILURE,
  DELETE_SYSTEM_WALLET_SERVICE_TYPE,
  DELETE_SYSTEM_WALLET_SERVICE_TYPE_SUCCESS,
  DELETE_SYSTEM_WALLET_SERVICE_TYPE_FAILURE,
  GET_SYSTEM_WALLET_SERVICE_RATE_LIST,
  GET_SYSTEM_WALLET_SERVICE_RATE_LIST_SUCCESS,
  GET_SYSTEM_WALLET_SERVICE_RATE_LIST_FAILURE,
  CREATE_SYSTEM_WALLET_SERVICE_RATE,
  CREATE_SYSTEM_WALLET_SERVICE_RATE_SUCCESS,
  CREATE_SYSTEM_WALLET_SERVICE_RATE_FAILURE,
  UPDATE_SYSTEM_WALLET_SERVICE_RATE,
  UPDATE_SYSTEM_WALLET_SERVICE_RATE_SUCCESS,
  UPDATE_SYSTEM_WALLET_SERVICE_RATE_FAILURE,
  DELETE_SYSTEM_WALLET_SERVICE_RATE,
  DELETE_SYSTEM_WALLET_SERVICE_RATE_SUCCESS,
  DELETE_SYSTEM_WALLET_SERVICE_RATE_FAILURE,
  SYSTEM_WALLET_RESET_RESPONSE,
} from "./actionType";

const initialState = {
  walletList: [],
  walletListLoading: false,
  walletData: [],
  walletDataLoading: false,
  walletUpdateResponse: [],
  walletUpdateLoading: false,
  walletTopUpResponse: [],
  walletTopUpLoading: false,
  walletTransactions: [],
  walletTransactionsLoading: false,
  walletAdjustResponse: [],
  walletAdjustLoading: false,

  // Customer-facing own wallet
  myWalletData: [],
  myWalletDataLoading: false,
  myWalletTransactions: [],
  myWalletTransactionsLoading: false,
  myWalletTopUpResponse: [],
  myWalletTopUpLoading: false,
  myWalletUpdateResponse: [],
  myWalletUpdateLoading: false,

  serviceTypeList: [],
  serviceTypeListLoading: false,
  serviceTypeCreateResponse: [],
  serviceTypeUpdateResponse: [],
  serviceTypeDeleteResponse: [],
  serviceTypeMutating: false,

  serviceRateList: [],
  serviceRateListLoading: false,
  serviceRateCreateResponse: [],
  serviceRateUpdateResponse: [],
  serviceRateDeleteResponse: [],
  serviceRateMutating: false,

  error: null,
};

const transientKeys = [
  "walletUpdateResponse",
  "walletTopUpResponse",
  "walletAdjustResponse",
  "myWalletTopUpResponse",
  "myWalletUpdateResponse",
  "serviceTypeCreateResponse",
  "serviceTypeUpdateResponse",
  "serviceTypeDeleteResponse",
  "serviceRateCreateResponse",
  "serviceRateUpdateResponse",
  "serviceRateDeleteResponse",
];

const SystemWallet = (state = initialState, action) => {
  switch (action.type) {
    // Wallet list
    case GET_SYSTEM_WALLET_LIST:
      return { ...state, walletListLoading: true };
    case GET_SYSTEM_WALLET_LIST_SUCCESS:
      return { ...state, walletListLoading: false, walletList: action.payload };
    case GET_SYSTEM_WALLET_LIST_FAILURE:
      return { ...state, walletListLoading: false, error: action.payload };

    // Single wallet
    case GET_SYSTEM_WALLET_DATA:
      return { ...state, walletDataLoading: true };
    case GET_SYSTEM_WALLET_DATA_SUCCESS:
      return { ...state, walletDataLoading: false, walletData: action.payload };
    case GET_SYSTEM_WALLET_DATA_FAILURE:
      return { ...state, walletDataLoading: false, error: action.payload };

    // Update
    case UPDATE_SYSTEM_WALLET:
      return { ...state, walletUpdateLoading: true };
    case UPDATE_SYSTEM_WALLET_SUCCESS:
      return {
        ...state,
        walletUpdateLoading: false,
        walletUpdateResponse: action.payload,
      };
    case UPDATE_SYSTEM_WALLET_FAILURE:
      return { ...state, walletUpdateLoading: false, error: action.payload };

    // Top-up
    case TOPUP_SYSTEM_WALLET:
      return { ...state, walletTopUpLoading: true };
    case TOPUP_SYSTEM_WALLET_SUCCESS:
      return {
        ...state,
        walletTopUpLoading: false,
        walletTopUpResponse: action.payload,
      };
    case TOPUP_SYSTEM_WALLET_FAILURE:
      return { ...state, walletTopUpLoading: false, error: action.payload };

    // Transactions
    case GET_SYSTEM_WALLET_TRANSACTIONS:
      return { ...state, walletTransactionsLoading: true };
    case GET_SYSTEM_WALLET_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        walletTransactionsLoading: false,
        walletTransactions: action.payload,
      };
    case GET_SYSTEM_WALLET_TRANSACTIONS_FAILURE:
      return {
        ...state,
        walletTransactionsLoading: false,
        error: action.payload,
      };

    // Adjust
    case ADJUST_SYSTEM_WALLET:
      return { ...state, walletAdjustLoading: true };
    case ADJUST_SYSTEM_WALLET_SUCCESS:
      return {
        ...state,
        walletAdjustLoading: false,
        walletAdjustResponse: action.payload,
      };
    case ADJUST_SYSTEM_WALLET_FAILURE:
      return { ...state, walletAdjustLoading: false, error: action.payload };

    // Customer-facing own wallet
    case GET_MY_WALLET:
      return { ...state, myWalletDataLoading: true };
    case GET_MY_WALLET_SUCCESS:
      return { ...state, myWalletDataLoading: false, myWalletData: action.payload };
    case GET_MY_WALLET_FAILURE:
      return { ...state, myWalletDataLoading: false, error: action.payload };

    case GET_MY_WALLET_TRANSACTIONS:
      return { ...state, myWalletTransactionsLoading: true };
    case GET_MY_WALLET_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        myWalletTransactionsLoading: false,
        myWalletTransactions: action.payload,
      };
    case GET_MY_WALLET_TRANSACTIONS_FAILURE:
      return {
        ...state,
        myWalletTransactionsLoading: false,
        error: action.payload,
      };

    case TOPUP_MY_WALLET:
      return { ...state, myWalletTopUpLoading: true };
    case TOPUP_MY_WALLET_SUCCESS:
      return {
        ...state,
        myWalletTopUpLoading: false,
        myWalletTopUpResponse: action.payload,
      };
    case TOPUP_MY_WALLET_FAILURE:
      return { ...state, myWalletTopUpLoading: false, error: action.payload };

    case UPDATE_MY_WALLET:
      return { ...state, myWalletUpdateLoading: true };
    case UPDATE_MY_WALLET_SUCCESS:
      return {
        ...state,
        myWalletUpdateLoading: false,
        myWalletUpdateResponse: action.payload,
      };
    case UPDATE_MY_WALLET_FAILURE:
      return { ...state, myWalletUpdateLoading: false, error: action.payload };

    // Service types
    case GET_SYSTEM_WALLET_SERVICE_TYPE_LIST:
      return { ...state, serviceTypeListLoading: true };
    case GET_SYSTEM_WALLET_SERVICE_TYPE_LIST_SUCCESS:
      return {
        ...state,
        serviceTypeListLoading: false,
        serviceTypeList: action.payload,
      };
    case GET_SYSTEM_WALLET_SERVICE_TYPE_LIST_FAILURE:
      return { ...state, serviceTypeListLoading: false, error: action.payload };

    case CREATE_SYSTEM_WALLET_SERVICE_TYPE:
    case UPDATE_SYSTEM_WALLET_SERVICE_TYPE:
    case DELETE_SYSTEM_WALLET_SERVICE_TYPE:
      return { ...state, serviceTypeMutating: true };
    case CREATE_SYSTEM_WALLET_SERVICE_TYPE_SUCCESS:
      return {
        ...state,
        serviceTypeMutating: false,
        serviceTypeCreateResponse: action.payload,
      };
    case UPDATE_SYSTEM_WALLET_SERVICE_TYPE_SUCCESS:
      return {
        ...state,
        serviceTypeMutating: false,
        serviceTypeUpdateResponse: action.payload,
      };
    case DELETE_SYSTEM_WALLET_SERVICE_TYPE_SUCCESS:
      return {
        ...state,
        serviceTypeMutating: false,
        serviceTypeDeleteResponse: action.payload,
      };
    case CREATE_SYSTEM_WALLET_SERVICE_TYPE_FAILURE:
    case UPDATE_SYSTEM_WALLET_SERVICE_TYPE_FAILURE:
    case DELETE_SYSTEM_WALLET_SERVICE_TYPE_FAILURE:
      return { ...state, serviceTypeMutating: false, error: action.payload };

    // Service rates
    case GET_SYSTEM_WALLET_SERVICE_RATE_LIST:
      return { ...state, serviceRateListLoading: true };
    case GET_SYSTEM_WALLET_SERVICE_RATE_LIST_SUCCESS:
      return {
        ...state,
        serviceRateListLoading: false,
        serviceRateList: action.payload,
      };
    case GET_SYSTEM_WALLET_SERVICE_RATE_LIST_FAILURE:
      return { ...state, serviceRateListLoading: false, error: action.payload };

    case CREATE_SYSTEM_WALLET_SERVICE_RATE:
    case UPDATE_SYSTEM_WALLET_SERVICE_RATE:
    case DELETE_SYSTEM_WALLET_SERVICE_RATE:
      return { ...state, serviceRateMutating: true };
    case CREATE_SYSTEM_WALLET_SERVICE_RATE_SUCCESS:
      return {
        ...state,
        serviceRateMutating: false,
        serviceRateCreateResponse: action.payload,
      };
    case UPDATE_SYSTEM_WALLET_SERVICE_RATE_SUCCESS:
      return {
        ...state,
        serviceRateMutating: false,
        serviceRateUpdateResponse: action.payload,
      };
    case DELETE_SYSTEM_WALLET_SERVICE_RATE_SUCCESS:
      return {
        ...state,
        serviceRateMutating: false,
        serviceRateDeleteResponse: action.payload,
      };
    case CREATE_SYSTEM_WALLET_SERVICE_RATE_FAILURE:
    case UPDATE_SYSTEM_WALLET_SERVICE_RATE_FAILURE:
    case DELETE_SYSTEM_WALLET_SERVICE_RATE_FAILURE:
      return { ...state, serviceRateMutating: false, error: action.payload };

    // Reset
    case SYSTEM_WALLET_RESET_RESPONSE: {
      const keys =
        Array.isArray(action.payload) && action.payload.length
          ? action.payload
          : transientKeys;
      const cleared = {};
      keys.forEach((k) => {
        cleared[k] = [];
      });
      return { ...state, ...cleared };
    }

    default:
      return state;
  }
};

export default SystemWallet;
